module.exports = __webpack_public_path__ + "static/media/enterprise-3.9c876546.jpg";